import React from 'react'
import { useNavigate } from 'react-router-dom'
import arrowLeft from '../../assets/icons/arrow-left.svg'
import Form from '../../components/student/AddForm'
import '../../styles/css/add-karyawan.css'
import Sidebar from '../../components/sidebar/Sidebar'
import { useEffect } from 'react'
import { resetForm, showFormError, storeSiswa, updateStateSiswa } from '../../features/siswaSlice'
import { useDispatch, useSelector } from 'react-redux'
import { getKategori } from '../../features/ketegoriSlice'
import { useState } from 'react'
import InfoBox from '../../components/InfoBox'
import LoadingFullscreen from '../../components/LoadingFullscreen'
import {getKelas} from "../../features/kelasSlice";

function AddSiswa() {
    let navigate = useNavigate()
    const dispatch = useDispatch()
    const {
        nama,
        niy,
        password,
        kelas,
        errors,
        loadingStore,
        statusResApi,
        messageResApi,
        isDisplayMessage,
        isFormValid
    } = useSelector((state) => state.siswa)
    const [showAlert, setShowAlert] = useState(false)
    const [isFormFilled, setIsFormFilled] = useState(false)


    useEffect(() => {
        dispatch(resetForm())
        dispatch(getKategori())
        dispatch(getKelas())
    }, [])

    async function addUser(e) {
        e.preventDefault();
        dispatch(showFormError())
        if (isFormValid) {

            dispatch(storeSiswa({
                nama: nama,
                niy: niy,
                password: password,
                class_id: kelas.id,


            }))
                .then((res) => {
                    if (res.meta.requestStatus === "fulfilled") {
                        navigate(-1)
                    }
                })
                .catch((err) => {
                    console.log(err);
                })
        }
    }

    function validateDisabled() {
        if (
            errors.nama === "" &&
            errors.email === "" &&
            errors.password === ""

        ) {
            return false
        } else {
            return true
        }
    }

    useEffect(() => {
        dispatch(updateStateSiswa({ name: 'isFormValid', value: !validateDisabled() }))
    }, [errors, validateDisabled()])

    useEffect(() => {
        if (
            nama.trim() !== ''
            || niy.trim() !== ''
            || password.trim() !== ''

        ) {
            setIsFormFilled(true)
        } else {
            setIsFormFilled(!validateDisabled())
        }

    }, [nama, niy, password, kelas])

    function handleBack() {
        if (isFormFilled) {
            setShowAlert(true)
        } else {
            navigate(-1)
        }
    }

    return (
        <div className='wrapper-karyawan'>
            <Sidebar />
            <div className='add-karyawan'>
                {isDisplayMessage &&
                    <InfoBox
                        message={messageResApi}
                        status={statusResApi}
                        isDisplay={isDisplayMessage}
                        setIsDisplay={updateStateSiswa}
                        stateName='isDisplayMessage'
                    />
                }
                <div className='navigation'>
                    <div>
                        <div className='wrapper-img' onClick={handleBack}>
                            <img src={arrowLeft} alt="" />
                        </div>
                        <h1>Tambah Siswa</h1>
                    </div>

                    <button
                        onClick={addUser}
                        className='btn-submit'
                    >
                        Konfirmasi
                    </button>
                </div>
                <div className='form-foto-profile'>
                    <Form />
                </div>

                {showAlert &&
                    <div className='bg-modal'>
                        <div className='alert-modal'>
                            <h1>Tambah Siswa</h1>
                            <p>Kamu yakin keluar halaman tambah karyawan? form akan terhapus</p>
                            <div>
                                <button onClick={() => setShowAlert(false)}>Tidak</button>
                                <button onClick={() => navigate(-1)}>Iya</button>
                            </div>
                        </div>
                    </div>
                }

                <LoadingFullscreen loading={loadingStore} />
            </div>
        </div>
    )
}

export default AddSiswa